import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';

import CommonTheme from '../../../Theme';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'none',
    position: 'relative',
  },
  container: {
    margin: '0',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: CommonTheme.palette.primary.main,
    color: '#fff',
  },
}));

export default function AddIconButton({isDisabled}) {
  const classes = useStyles();

  return (
    <div id="btnTblFooter" className={classes.root} >
      <Fab id="btnAddRow" aria-label="add" size="small"
        className={classes.container}
        disabled={isDisabled}>
        <AddIcon id="btnAddRow"/>
      </Fab>
    </div>
  );
};

AddIconButton.propTypes = {
  isDisabled: PropTypes.bool,
};
